import PropTypes from 'prop-types';
import React from 'react';
import Loading from './loader.jsx';

export default class Eula extends React.Component {
    static displayName = 'Eula';

    static propTypes = {
        signEula: PropTypes.func.isRequired,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    async componentDidMount() {
        const eula = await fetch('/eula.html')
            .then(res => res.ok && res.text())
            .catch(err => {
                /* eslint-disable no-console */
                console.error(err);
                /* eslint-enable no-console */
            });
        if (eula) {
            this.setState({ html: eula });
        }
    }

    render() {
        const { html } = this.state;
        const { signEula } = this.props;
        if (html == null) {
            return <Loading />;
        }

        return (
            <div id="eula">
                <div className="logo" />
                <span dangerouslySetInnerHTML={{ __html: html }} />
                <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={signEula}
                >
                    I Agree
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/eula.jsx